import React from 'react';

import Logo from './Logo';
const apiBaseURL = process.env.REACT_APP_API_URL;

const ProjectLogo = ({
  src,
  width = 50,
  height = 50,
  className = '',
  ...others
}) =>
  src ? (
    <img
      className={`u-margin-right-tiny u-img-round ${className}`}
      alt="Project Logo"
      src={`${apiBaseURL}projects/thumb-210x210-${src}`}
      {...others}
      width={width}
      height={height}
    />
  ) : (
    <Logo
      width={width}
      height={height}
      className="u-margin-right-tiny u-opacity-half"
    />
  );

export default ProjectLogo;



// WEBPACK FOOTER //
// ./src/common/ProjectLogo.js